import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const InsurancePercentage = () => {
  const [balance, setBalance] = useState(null);
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.chinaTomi;
  const tokenAddress1 = Environment.busd;
  const contract = chinaContract(tokenAddress, web3);

  const insurancePercentage = useCallback(async () => {
    // console.log(tokenAddress,account,'noor');
    try {
      const buy = await contract.methods.insuranceFeePPM().call();
      // console.log('sdsdss' ,  buy)
      return buy / 10 ** 4;
    } catch (error) {
      throw error;
    }
  }, [contract, account]);
  return { insurancePercentage: insurancePercentage };
};
export default InsurancePercentage;
